// @ts-ignore
import React, { FC, memo } from 'react';
import TournamentAnchor from '@om-fe/core/components/tournament-anchor/tournament-anchor';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import { BemMethod, createBem } from '@om-fe/utils';
import { FavoriteTournamentsButton } from '@om-fe/core/components/favorites/favorite.utils';
import { DisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import { MixedGroupedTournamentModel } from '../../mixed-grouped.types';
import { UseSimpleStore, useSimpleStoreItem } from '@om-fe/store';

const bem: BemMethod = createBem('MixedGroupTournamentHeader');

export interface MixedGroupTournamentHeaderProps {
    readonly useStore: UseSimpleStore<MixedGroupedTournamentModel>;
    readonly id: string;
    readonly open: boolean;
    readonly sportPageType: DisciplineRouteType;
    readonly onToggle: () => void;
}

export const MixedGroupTournamentHeader: FC<MixedGroupTournamentHeaderProps> = memo((
    {
        useStore,
        id,
        open,
        sportPageType,
        onToggle,
    }: MixedGroupTournamentHeaderProps,
) => {
    const tournament: MixedGroupedTournamentModel = useSimpleStoreItem<MixedGroupedTournamentModel>(useStore, id);

    const {
        sportId,
        sportName,
        name,
        locationId,
        locationName,
        categoryId,
        categoryName,
        shortTranslatedName,
    } = tournament;

    return (
        <div className={bem()} onClick={onToggle}>
            <FavoriteTournamentsButton tournamentId={id} />
            <TournamentAnchor
                className={bem('Title')}
                disciplineId={sportId}
                disciplineName={sportName}
                tournamentId={id}
                tournamentName={name}
                locationId={sportPageType === DisciplineRouteType.Location && locationId}
                locationName={sportPageType === DisciplineRouteType.Location && locationName}
                categoryId={sportPageType === DisciplineRouteType.Category && categoryId}
                categoryName={sportPageType === DisciplineRouteType.Category && categoryName}
            >
                {shortTranslatedName}
            </TournamentAnchor>
            <div className={bem('ToggleWrapper')}>
                <GeneralIcon
                    className={bem('Toggle')}
                    name={open ? 'remove' : 'add'}
                />
            </div>
        </div>
    );
});
